import { createMuiTheme } from '@material-ui/core/styles';
import { Personnalisation } from './services/Api/swagger';
import { error, grisClair, grisMoyen, palettePrimary, primaryBlack, redLight, redMain, success, textHint } from './theme';

export const createCustomTheme = (personnalisation: Personnalisation) => {

  const customGrisClair = grisClair;
  const customPalettePrimary = palettePrimary;
  const customGrisMoyen = grisMoyen;

  const customLight = personnalisation?.theme?.hexaCouleurTheme1 ? personnalisation.theme.hexaCouleurTheme1 : redLight;
  const customMain = personnalisation?.theme?.hexaCouleurTheme2 ? personnalisation.theme.hexaCouleurTheme2 : redMain;
  const customPrimaryBlack = primaryBlack;

  const customTextHint = textHint;
  const customError = error;
  const customSuccess = success;

  const customTheme = createMuiTheme({
      palette: {
        primary: {
          light: customGrisClair,
          main: customPalettePrimary,
          dark: customGrisMoyen,
        },

        secondary: {
          light: customLight,
          main: customMain,
          dark: customPrimaryBlack,
        },
        text: {
          hint: customTextHint,
        },
        error: {
          main: customError,
        },
        success: {
          main: customSuccess,
        }
      },
      typography: {
        fontFamily: ['Mulish, sans-serif'].join(','),
        h1: { fontSize: 40, color: customLight, fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
        h2: { fontSize: 33, color: customLight, fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
        h3: { fontSize: 23, color: customLight, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
        h4: { fontSize: 15, color: customPrimaryBlack, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
        h5: { fontSize: 14, color: customMain, fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
        body1: { fontSize: 14, color: 'black', "& a": { color: customMain}, },
        body2: { color: customGrisMoyen },
        button: { fontSize: 17, fontFamily: 'Poppins, sans-serif', fontWeight: 500 },
      },
      overrides: {
        MuiPickersDay: {
          current: {
            color: customMain,
          },
        },
      },
  });
  return customTheme;
}